module.exports = __webpack_public_path__ + "static/media/tw.587d478a.svg";